import usePersist from "./usePersist";
import { useLoadConfig } from "./configs/LoadConfig";
function useReload(key, options) {
  var _useLoadConfig = useLoadConfig(),
    store = _useLoadConfig.store;
  var reload = usePersist(function (params) {
    var force = !!params && !!params.force || !!options && !!options.force;
    store.getReloaders(key).forEach(function (reload) {
      reload({
        force: force
      });
    });
  });
  return reload;
}
export default useReload;